import { useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";


import Page from "ui/Page";

import SignupForm from "areas/partners/ui/SignupForm";


export default function Signup() {
	const theme = useTheme();

	const style = {
		body: { mt: theme.spacing(2), gap: theme.spacing(2) }
	};
	return (
		<Page maxWidth="sm">
			<Page.Header title="Register your publication" subtitle="Submit a request to add your publication to Subly" />
			<Divider flexItem />
			<Page.Body sx={style.body}>
				<SignupForm />
			</Page.Body>
		</Page>
	);
}